import React from 'react';
import Lottie from 'lottie-react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import fixedPriceTrialAnimation from '@images/animations/fixedPriceTrialAnimation.json';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-lg-6 mb-4 limit-text">
						<h1
							className={classNames(
								styles.header,
								'font-size-large pb-2 mb-3 mt-0'
							)}
						>
							Fixed-price trial
						</h1>
						<p className="font-size-sm pr-2 pr-sm-4 pr-md-0">
							This cooperation model is unique - only for the beginning of the
							first trial of a small project with a new client. With a specific
							budget, you can expect certain results.
						</p>
						<p className="font-size-md mt-5 font-600">
							Is the fixed-price trial for me?
						</p>
						<p className="font-size-sm mt-2">
							This model will be accurate when you want to check how EMBIQ
							works. If you want us to prepare something for you as part of this
							trial, some small piece of the project, we can enter it for a
							trial. For example, we can do small work - such as mockups. It is
							up to you.
						</p>
					</div>
					<div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
						<Lottie
							className={styles.animation}
							animationData={fixedPriceTrialAnimation}
							loop={true}
						/>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
